import { render } from "./containerDialog.vue?vue&type=template&id=35d6c4a7"
import script from "./containerDialog.vue?vue&type=script&lang=js"
export * from "./containerDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__